import styled from '@emotion/styled';
import { useLocation, useSearchParams } from 'react-router-dom';

import { formatNumber } from '@/utils/formatting';

interface PaymentModalProps {
	closeModal: (bool: boolean) => void;
}
const CompleteModal = ({ closeModal }: PaymentModalProps) => {
	const [searchParams] = useSearchParams();
	const location = useLocation();
	const goodsName = location.pathname.split('/')[1] === 'membership';
	const memberTypeParams = searchParams.get('member_type') ?? '';
	const amountParams = searchParams.get('amount') ?? '';
	const companyParams = searchParams.get('company_code') ?? '';
	const cardNoParams = searchParams.get('card_no') ?? '';

	return (
		<PaymentContainer>
			<Title>납부 완료</Title>
			<PaymentAccountBox>
				{goodsName && (
					<div className="item">
						<div className="title">회원구분</div>
						<div className="content point">
							<div className="content">{memberTypeParams}</div>
						</div>
					</div>
				)}

				<div className="item">
					<div className="title">결제금액</div>
					<div className="content point">
						<strong className="point_bold">{formatNumber(amountParams)}</strong>원
					</div>
				</div>
				<div className="item">
					<div className="title">결제카드</div>
					<div className="content">
						{companyParams}&nbsp;
						<strong className="point_bold">{cardNoParams}</strong>
					</div>
				</div>
			</PaymentAccountBox>

			<PaymentButtonBox>
				<PaymentConfirmButton
					type="button"
					onClick={() => {
						closeModal(false);
					}}
				>
					확인
				</PaymentConfirmButton>
			</PaymentButtonBox>
		</PaymentContainer>
	);
};

export default CompleteModal;

// ✅ 스타일 정의

const PaymentContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	gap: 2rem;
`;
const Title = styled.h2`
	font-size: ${(props) => props.theme.fontSize.sizeXl};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: 130%;
	letter-spacing: -0.6px;
	color: #212529;
`;

const PaymentButtonBox = styled.div`
	display: flex;
	justify-content: space-between;
	width: 100%;
	gap: 1.2rem;
`;
const PaymentConfirmButton = styled.button`
	background-color: ${(props) => props.theme.colors.primary400};
	color: #ffffff;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	letter-spacing: -0.6px;
	line-height: 100%;
	width: 100%;
	padding: 0rem 1.2rem;
	height: 4.4rem;
	border: none;
	cursor: pointer;
	&:disabled {
		background-color: #e9ecef;
		color: #868e96;
		cursor: not-allowed;
	}
`;

export const GenderBox = styled.div`
	display: flex;
	gap: 4rem;
`;

export const GenderRadio = styled.div`
	display: flex;
	gap: 0.4rem;
	align-items: center;
	input[type='radio'] {
		-webkit-appearance: none; // 웹킷 브라우저에서 기본 스타일 제거
		-moz-appearance: none; // 모질라 브라우저에서 기본 스타일 제거
		appearance: none; // 기본 브라우저에서 기본 스타일 제거
		width: 20px;
		height: 20px;
		border: 1px solid #ced4da; // 체크되지 않았을 때의 테두리 색상
		border-radius: 50%;
		outline: none; // focus 시에 나타나는 기본 스타일 제거
		cursor: pointer;
	}
	// 체크 시 버튼 모양 스타일
	input[type='radio']:checked {
		background-color: #fff; // 체크 시 내부 원 색상
		border: 6px solid ${(props) => props.theme.colors.primary400}; // 라인이 아닌, 라인과 원 사이 색상
	}
`;

export const PaymentAccountBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.6rem;
	background-color: #fff;
	.item {
		display: flex;
		flex-direction: column;
		gap: 0.4rem;
		.title {
			font-size: ${(props) => props.theme.fontSize.sizeLg};
			font-weight: ${(props) => props.theme.fontWeight.weightSemi};
			line-height: 130%;
			letter-spacing: -0.6px;
			color: #212529;
		}
		.content {
			font-size: ${(props) => props.theme.fontSize.sizeLg};
			font-weight: ${(props) => props.theme.fontWeight.weightRegular};
			line-height: 130%;
			letter-spacing: -0.6px;
			color: #212529;
		}
		.point_bold {
			color: ${(props) => props.theme.colors.primary400};
			font-weight: ${(props) => props.theme.fontWeight.weightSemi};
		}
		.point {
			color: ${(props) => props.theme.colors.primary400};
		}
	}
`;
